import { createSlice } from "@reduxjs/toolkit";

import * as API from "../config/api";
import { ApiRest } from "react-comun-seps/lib/api/ApiRest";

const initialState = {
  messageSuccess: "",
  messageError: "",
  listaEstadosJuridico: {},
};

export const reservaSlice = createSlice({
  name: "reservaSlice",
  initialState,
  reducers: {
    setEstadoJuridico: (state, action) => {
      state.listaEstadosJuridico = action.payload;
    },
    setMessageSuccess: (state, action) => {
      state.messageSuccess = action.payload;
    },
    setMessageError: (state, action) => {
      state.messageError = action.payload;
    },
  },
});

export const { setEstadoJuridico, setMessageSuccess, setMessageError } = reservaSlice.actions;

export const obtenerEstadoJuridico = () => async (dispatch) => {
  try {
    const result = await ApiRest.get(`${API.URL_GET_TIPOS_IDENTIFICACION}?nemGrupo=REGULARIZACION`);
    dispatch(setEstadoJuridico(result.data));
  } catch (ex) {
    handleException(ex, dispatch);
  }
};

function handleException(exception, dispatch) {
  if (typeof exception === "string") {
    dispatch(setMessageError(exception));
  } else {
    dispatch(setMessageError(exception.data?.message || exception.data));
  }
}

export default reservaSlice.reducer;
